module.exports = __webpack_public_path__ + "static/media/exhibition-services-img5.5bbb187d.jpg";